import styled from 'styled-components/macro';

export interface ButtonStyleProps {
  hoverOpacity?: number;
  activeOpacity?: number;
}

export const Btn = styled.button<ButtonStyleProps>`
  border: none;
  white-space: nowrap;
  background-color: transparent;
  -webkit-tap-highlight-color: transparent;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-left: 0;
  padding-right: 0;

    &:hover {
      opacity: ${({ hoverOpacity }) => (hoverOpacity != null ? hoverOpacity : '0.8')};
    }

    &:active {
      opacity: ${({ activeOpacity }) => (activeOpacity != null ? activeOpacity : '0.8')};
      transform: scale(0.95);
    }
`;
